// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import 'babel-polyfill';
import axios from 'axios';
import $ from 'jquery';
import store from "./store/store"
import axiosG from "./http"
import './assets/iconfont/iconfont.css'

Vue.prototype.$ajax=axios;

Vue.use(iView)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
	axiosG,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js